import * as actionTypes from '../actions/actionTypes';

const initialState = {
    ticket: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SAVE_TICKET_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                ticket: null
            };
        case actionTypes.SAVE_TICKET_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                ticket: null
            };
        case actionTypes.SAVE_TICKET_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                ticket: null
            };
        case actionTypes.SAVE_TICKET_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                ticket: action.payload.id
            };
        default:
            return state;
    }
};

export default reducer;